import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Button,
  FormLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "../../../components/ui";
import axiosInstance from "../../../axios/axiosInstance";
import { toast } from "react-toastify";
import { handeleUpdateStatus } from "../../../utils/update-request-status";

interface Prop {
  onClose: () => void;
  id?: any;
  requestData?: any;
  requestId?: any;
}
const vehicleTypes = [
  { value: "car", label: "Car" },
  { value: "bike", label: "Bike" },
  { value: "truck", label: "Truck" },
  { value: "motorcycle", label: "Motorcycle" },
  { value: "bus", label: "Bus" },
  { value: "van", label: "Van" },
  { value: "other", label: "Other" },
];
const VehicleFrom: React.FC<Prop> = ({
  onClose,
  id,
  requestData,
  requestId,
}) => {
  const role = localStorage.getItem("role");
  const [formData, setFormData] = useState<any>();
  const [initialFormData, setInitialFromData] = useState<any>();

  const handleChange = (key: any, value: any) => {
    setFormData({ ...formData, [key]: value });
  };

  // const handleGetVehicle = async (id: any) => {
  //   try {
  //     const resp: any = await axiosInstance.get(`/api/vehicle/${id}`);
  //     if (resp?.status === 200) {
  //       setFormData(resp.data?.data);
  //     }
  //   } catch (Error: any) {
  //     toast.error("Error getting user");
  //   }
  // };

  const handleSave = async () => {
    if (!formData?.reg_no) {
      toast.error("Reg No is required");
      return;
    }
    if (!formData?.type) {
      toast.error("Vehicle Type is required");
      return;
    }

    if (requestData) {
      if (!(JSON.stringify(formData) === JSON.stringify(initialFormData))) {
        formData.is_admin_made_change = true;
      }
    }
    formData.role = role;
    // When approving a request, execute directly without invocation
    if (!formData?.id) {
      try {
        const url = requestId 
          ? `/api/vehicle` 
          : `/api/vehicle?invocation=${role}`;
        
        const resp: any = await axiosInstance.post(url, formData);
        if (resp?.status === 200) {
          if (requestId) {
            handeleUpdateStatus(requestId, "1");
          }
          if (requestId) {
            toast.success("Request approved and vehicle created successfully");
          } else {
            toast.success("Vehicle Created successfully");
          }
          onClose();
        }
      } catch (Error: any) {
        toast.error(Error?.response?.data?.body || Error?.message || "Error create vehicle");
      }
    } else {
      try {
        const url = requestId 
          ? `/api/vehicle/${formData?.id}` 
          : `/api/vehicle/${formData?.id}?invocation=${role}`;
        
        const resp: any = await axiosInstance.put(url, formData);
        if (resp?.status === 200) {
          if (requestId) {
            handeleUpdateStatus(requestId, "1");
          }
          if (requestId) {
            toast.success("Request approved and vehicle updated successfully");
          }
          onClose();

          toast.success("Vehicle updated successfully");
        }
      } catch (Error: any) {
        toast.error("Error updating vehicle");
      }
    }
  };

  useEffect(() => {
    console.log("reqqq", requestData);

    setFormData(requestData);
    setInitialFromData(requestData);
  }, [requestData]);

  return (
    <div>
      <Grid container spacing={2}>
        <Grid size={12}>
          {" "}
          <Typography variant="h6" fontWeight={600}>
            Vehicle Registration
          </Typography>
        </Grid>
        <Grid size={12}>
          <Box display={"grid"} width={"100%"}>
            <FormLabel>Registration No</FormLabel>
            <TextField
              size="small"
              id="outlined-basic"
              variant="outlined"
              value={formData?.reg_no}
              onChange={(e: any) => handleChange("reg_no", e?.target.value)}
            />
          </Box>
        </Grid>
        <Grid size={12}>
          <Box display={"grid"} width={"100%"}>
            <FormLabel>Vehicle Type</FormLabel>

            <Select
              size="small"
              value={formData?.type ? formData?.type : 0}
              onChange={(e: any) => handleChange("type", e?.target.value)}
            >
              {vehicleTypes.map((item: any) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Grid>
        <Grid size={12}>
          <Box display={"display"}>
            <Button
              variant="contained"
              size="small"
              sx={{ mx: 1, bgcolor: "#1F2937" }}
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              variant="outlined"
              size="small"
              sx={{ color: "#1F2937", borderColor: "#1F2937" }}
              onClick={onClose}
            >
              Close
            </Button>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default VehicleFrom;
